<template>
    <div class="product03">
        <div class="row">
            <div class="col">
                <h3>在庫管理システム（Simple在庫）</h3>

                <h4>在庫管理を、もっとシンプルに。</h4>
                <div class="text-left">
                    <p class="p-3">
                        多くの市販在庫管理システムは、機能が非常に多く、操作画面も複雑です。
                        <br />
                        そのため、導入しても「使いこなせない」といった不安から、導入に踏み切れない企業が少なくありません。
                        <br />
                        <br />
                        実際には、中小企業の日々の業務に必要な機能はもっとシンプルで十分です。
                        <br />
                        しかし、市販システムには不要な機能が多く含まれており、その分、費用も高額になりがちです。
                        <br />
                        「高機能＝高価格」という構図の中で、「本当に必要なことだけを、わかりやすく、低コストで実現したい」という声が多く聞かれます。
                        <br />
                        <br />
                        Simple在庫は、まさにこうしたニーズに応えるために開発された、
                        <mark>中小企業向けのちょうどいい在庫管理システム</mark>
                        です。
                    </p>
                </div>
                <h4>よくある課題、Simple在庫でこう変わる</h4>
                <div class="p-3">
                    <table class="table">
                        <thead>
                            <th>課題</th>
                            <th>Simple在庫ができること</th>
                        </thead>
                        <tbody>
                            <tr>
                                <th class="table-warning" width="200">Excel管理の限界</th>
                                <td>
                                    Web化で在庫情報をリアルタイム共有。
                                    <br />
                                    もう「最新のファイルはどれ？」と迷わない。
                                </td>
                            </tr>
                            <tr>
                                <th class="table-warning">在庫の見える化不足</th>
                                <td>
                                    どこに何が、いくつあるかが一目でわかる！
                                    <br />
                                    倉庫・製品ごとの在庫をリアルタイムで可視化。
                                </td>
                            </tr>
                            <tr>
                                <th class="table-warning">在庫差異や誤操作</th>
                                <td>
                                    承認フロー＋在庫情報の一元管理・リアルタイム更新により、担当者単独での変更や誤操作を防止。
                                    <br />
                                    帳簿とのズレや不正リスクを低減し、在庫の信頼性を確保。
                                </td>
                            </tr>
                            <tr>
                                <th class="table-warning">システム導入への不安</th>
                                <td>
                                    不要な機能を省いたシンプル設計で直感的に使え、業務フローに合わせた柔軟なカスタマイズが可能。
                                    <br />
                                    初期費用・月額ともに低コストでスモールスタートでき、クラウド環境によるサーバ不要で管理負担も大幅に軽減できる。
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h4>機能概要一覧</h4>
                <div class="p-3">
                    <h5>一般利用者機能</h5>
                    <table class="table">
                        <tbody>
                            <tr>
                                <th class="table-warning" width="200">ログイン</th>
                                <td>ユーザーIDとパスワードでログイン。複数事業者の場合は、事業者の選択が必要</td>
                            </tr>
                            <tr>
                                <th class="table-warning">ダッシュボード</th>
                                <td>製品ごとの在庫数を保管場所別・総数で表示。保管場所ごとの在庫状況確認や承認ステータスでの切替表示が可能</td>
                            </tr>
                            <tr>
                                <th class="table-warning">入庫</th>
                                <td>入庫日、製品、数量、仕入先、保管場所等を入力し、在庫登録</td>
                            </tr>
                            <tr>
                                <th class="table-warning">出庫</th>
                                <td>出庫日、製品、数量、保管場所、販売先等を入力し、出庫登録</td>
                            </tr>
                            <tr>
                                <th class="table-warning">在庫移動</th>
                                <td>移動日、製品、数量、移動元・移動先保管場所等を入力して在庫移動登録</td>
                            </tr>
                            <tr>
                                <th class="table-warning">入出庫履歴</th>
                                <td>検索条件による履歴表示、履歴クリックで詳細確認、更新・削除・承認・承認取消が可能</td>
                            </tr>
                        </tbody>
                    </table>

                    <h5 class="mt-4">管理者機能</h5>
                    <table class="table">
                        <tbody>
                            <tr>
                                <th class="table-warning" width="200">設定</th>
                                <td>事業者の基本情報設定、メール通知やTeams通知設定が可能</td>
                            </tr>
                            <tr>
                                <th class="table-warning">ユーザ管理</th>
                                <td>ユーザーの一覧表示、新規登録・変更・削除・無効化</td>
                            </tr>
                            <tr>
                                <th class="table-warning">カテゴリ管理</th>
                                <td>カテゴリの一覧表示、新規追加・変更・削除・表示順変更・無効化</td>
                            </tr>
                            <tr>
                                <th class="table-warning">製品管理</th>
                                <td>カテゴリ別に製品一覧を表示し、登録・更新・削除・表示順変更・無効化が可能</td>
                            </tr>
                            <tr>
                                <th class="table-warning">在庫保管場所管理</th>
                                <td>保管場所の一覧表示、新規追加・変更・削除・表示順変更・無効化</td>
                            </tr>
                            <tr>
                                <th class="table-warning">取引先管理</th>
                                <td>取引区分別に取引先一覧を表示し、登録・更新・削除・表示順変更・無効化が可能</td>
                            </tr>
                        </tbody>
                    </table>

                    <h4 class="mt-5">技術キーワード</h4>
                    <table class="table">
                        <tbody>
                            <tr>
                                <th class="table-warning" width="200">フロントエンド</th>
                                <td>Vue.js、Bootstrap</td>
                            </tr>
                            <tr>
                                <th class="table-warning">バックエンド</th>
                                <td>Node.js</td>
                            </tr>
                            <tr>
                                <th class="table-warning">データベース</th>
                                <td>MySQL</td>
                            </tr>
                            <tr>
                                <th class="table-warning">稼働環境</th>
                                <td>AWS（Amazon Web Services）</td>
                            </tr>
                            <tr>
                                <th class="table-warning">その他</th>
                                <td>メール/Teams連携</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <h4>画面イメージ</h4>

                <div class="p-3 text-center">
                    <h5 class="text-center">ログイン画面</h5>
                    <img src="../../assets/product03/01.png" class="img-fluid mb-2" style="max-width: 600px" />
                </div>

                <div class="p-3 text-center">
                    <h5 class="text-center">ダッシュボード（商品単位表示）画面</h5>
                    <img src="../../assets/product03/02.png" class="img-fluid mb-2" style="max-width: 600px" />
                </div>
                <div class="p-3 text-center">
                    <h5 class="text-center">ダッシュボード（商品単位表示）画面</h5>
                    <img src="../../assets/product03/02.png" class="img-fluid mb-2" style="max-width: 600px" />
                </div>
                <div class="p-3 text-center">
                    <h5 class="text-center">ダッシュボード（倉庫単位表示）画面</h5>
                    <img src="../../assets/product03/03.png" class="img-fluid mb-2" style="max-width: 600px" />
                </div>
                <div class="p-3 text-center">
                    <h5 class="text-center">入出庫履歴画面</h5>
                    <img src="../../assets/product03/04.png" class="img-fluid mb-2" style="max-width: 600px" />
                </div>
                <div class="p-3 text-center">
                    <h5 class="text-center">入庫画面</h5>
                    <img src="../../assets/product03/05.png" class="img-fluid mb-2" style="max-width: 600px" />
                </div>
                <div class="p-3 text-center">
                    <h5 class="text-center">出庫画面</h5>
                    <img src="../../assets/product03/06.png" class="img-fluid mb-2" style="max-width: 600px" />
                </div>
                <div class="p-3 text-center">
                    <h5 class="text-center">在庫移動画面</h5>
                    <img src="../../assets/product03/07.png" class="img-fluid mb-2" style="max-width: 600px" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Product02Page",
    components: {},
    data: function () {
        return {};
    },
    methods: {},
};
</script>
